// extracted by mini-css-extract-plugin
export var grid = "recipeGrid-module--grid--E4cRM";
export var gridEmphasized = "recipeGrid-module--grid-emphasized--aiFcb";
export var gridItem = "recipeGrid-module--grid-item--v5bGE";